import { Field } from '@/components/common/Field'
import { inputClass } from '@/components/common/formStyles'

interface ConfigFieldEditorProps {
  fieldKey: string
  value: unknown
  onChange: (next: unknown) => void
}

export function ConfigFieldEditor({ fieldKey, value, onChange }: ConfigFieldEditorProps) {
  if (typeof value === 'boolean') {
    return (
      <Field label={fieldKey}>
        <label className="flex items-center gap-2 text-sm text-ink">
          <input type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} />
          {value ? 'true' : 'false'}
        </label>
      </Field>
    )
  }
  if (typeof value === 'number') {
    return (
      <Field label={fieldKey}>
        <input
          type="number"
          step="any"
          value={value === 0 ? '' : value}
          onChange={(e) => {
            const raw = e.target.value
            if (raw === '') {
              onChange(0)
              return
            }
            const num = Number(raw)
            onChange(Number.isFinite(num) ? num : 0)
          }}
          placeholder="0"
          className={inputClass}
        />
      </Field>
    )
  }
  if (typeof value === 'string') {
    return (
      <Field label={fieldKey}>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={inputClass}
        />
      </Field>
    )
  }
  return (
    <Field label={`${fieldKey} (nicht editierbar)`}>
      <code className="break-all text-xs text-muted">{JSON.stringify(value)}</code>
    </Field>
  )
}
